import { useState } from "react";
import { ChevronsUpDown } from "lucide-react";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Command, CommandEmpty, CommandGroup, CommandInput, CommandItem, CommandList } from "@/components/ui/command";

const inputCls = "rounded-none h-12 border-ink/20 focus-visible:ring-flame";

export const SearchSelect = ({ selectedIso, onSelect, placeholder, testid, renderOption, renderSelected, options, hasError }) => {
  const [open, setOpen] = useState(false);
  const selected = options.find((o) => o.id === selectedIso);
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <button type="button" data-testid={testid}
          className={`${inputCls} w-full bg-transparent border flex items-center justify-between px-3 text-left text-sm font-medium ${hasError ? "border-red-500" : ""}`}>
          <span className={selected ? "" : "text-ink/40"}>{selected ? renderSelected(selected) : placeholder}</span>
          <ChevronsUpDown className="w-4 h-4 text-ink/40 shrink-0 ml-2" />
        </button>
      </PopoverTrigger>
      <PopoverContent className="p-0 rounded-none w-[var(--radix-popover-trigger-width)]" align="start">
        <Command>
          <CommandInput placeholder="Type to search..." data-testid={`${testid}-search`} />
          <CommandList className="max-h-60">
            <CommandEmpty>No match found.</CommandEmpty>
            <CommandGroup>
              {options.map((o) => (
                <CommandItem key={o.id} value={o.search} onSelect={() => { onSelect(o.id); setOpen(false); }}
                  data-testid={`${testid}-option-${o.id.toLowerCase().replace(/[^a-z0-9]+/g, "-")}`}>
                  {renderOption(o)}
                </CommandItem>
              ))}
            </CommandGroup>
          </CommandList>
        </Command>
      </PopoverContent>
    </Popover>
  );
};
